import { RULE_TYPES } from '../config/rules.config';
import { applyDomainRuleOverrides } from '../config/rules.overrides';
import { getTargetKey } from './ruleTargetHelpers';

const SPECIAL_RULE_KEYS = new Set([
  RULE_TYPES.LOCK_WHEN_CHECKED,
  RULE_TYPES.DISABLE_WHEN_CHECKED,
  RULE_TYPES.SPECIAL_CONDITION,
]);

export function resolveRules(rules, availableKeySet, domain) {
  const resolved = {};

  Object.entries(rules).forEach(([ruleType, ruleConfig]) => {
    if (!ruleConfig) {
      resolved[ruleType] = ruleConfig;
      return;
    }

    if (!SPECIAL_RULE_KEYS.has(ruleType)) {
      const parentAvailable =
        !ruleConfig.parentKey || availableKeySet.has(ruleConfig.parentKey);
      resolved[ruleType] = {
        ...ruleConfig,
        enabled: ruleConfig.enabled && parentAvailable,
      };
      return;
    }

    if (ruleType === RULE_TYPES.SPECIAL_CONDITION) {
      const targets = {};
      Object.entries(ruleConfig.targets || {}).forEach(([targetKey, condition]) => {
        if (!availableKeySet.has(targetKey)) return;
        if (condition.requiresAny) {
          const requiresAny = condition.requiresAny.filter((key) =>
            availableKeySet.has(key),
          );
          if (requiresAny.length === 0) {
            return;
          }
          targets[targetKey] = { ...condition, requiresAny };
          return;
        }
        targets[targetKey] = condition;
      });
      resolved[ruleType] = { ...ruleConfig, targets };
      return;
    }

    const targets = {};
    Object.entries(ruleConfig.targets || {}).forEach(([triggerKey, lockedList]) => {
      if (!availableKeySet.has(triggerKey)) return;
      const filteredList = (lockedList || []).filter((entry) =>
        availableKeySet.has(getTargetKey(entry)),
      );
      if (filteredList.length === 0) return;
      targets[triggerKey] = filteredList;
    });
    resolved[ruleType] = { ...ruleConfig, targets };
  });

  return applyDomainRuleOverrides(resolved, domain);
}
